import { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Copy, Check, Clock } from "lucide-react";
import { toast } from "sonner";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/hours";

export default function PhoneBar() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(PHONE_DISPLAY);
      setCopied(true);
      toast.success("Numéro copié !");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copie impossible");
    }
  };

  return (
    <section data-testid="phone-order-bar" className="relative overflow-hidden bg-terra py-20 lg:py-24">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-flame/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-black/20 blur-3xl" />
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative mx-auto max-w-5xl px-5 text-center lg:px-8"
      >
        <img src="/images/palmi-logo-white.png" alt="PALMI Pizza Club" className="mx-auto mb-8 h-16 w-auto sm:h-20" />
        <p className="font-code text-xs uppercase tracking-[0.3em] text-[#FDFBF7]/80">Une envie ? Un coup de fil suffit.</p>
        <a
          data-testid="phone-number-call-link"
          href={PHONE_TEL}
          className="font-display mt-4 block whitespace-nowrap text-[6.8vw] font-extrabold tracking-tight text-[#FDFBF7] transition-transform hover:scale-[1.02] sm:text-6xl lg:text-7xl"
        >
          {PHONE_DISPLAY}
        </a>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a href={PHONE_TEL} className="inline-flex items-center gap-2 rounded-full bg-[#0F0D0B] px-7 py-3.5 font-semibold text-[#FDFBF7] transition-transform hover:scale-105">
            <Phone size={17} /> Appeler maintenant
          </a>
          <button
            data-testid="phone-number-copy-button"
            onClick={copy}
            className="inline-flex items-center gap-2 rounded-full border border-[#FDFBF7]/40 px-7 py-3.5 font-semibold text-[#FDFBF7] transition-colors hover:bg-[#FDFBF7]/10"
          >
            {copied ? <Check size={17} /> : <Copy size={17} />} {copied ? "Copié" : "Copier le numéro"}
          </button>
        </div>
        <p className="mt-6 inline-flex items-center gap-2 text-sm text-[#FDFBF7]/85">
          <Clock size={15} /> Retrait au comptoir · Paiement sur place.
        </p>
      </motion.div>
    </section>
  );
}
